export default "__VITE_ASSET__jaK4UmRo__"